import { createBrowserHistory } from 'history';
//////////////////////////////////////////////////

const history = createBrowserHistory();

const getCurrentPathname = () => window.location.pathname;

export {
  history,
  getCurrentPathname,
};
